module.exports = __webpack_public_path__ + "static/media/man.2c546731.jpg";